<template>
    <div>
        <div class="card-body" v-loading="$parentInfo.studentPeriod.switchingPeriod.loading">
            <el-form label-position="left" label-width="100px">
                <div class="card" v-for="applyDetail in $parentInfo.studentPeriod.applyReasons.applyDetails">
                    <el-row :span="20" >
                        <el-col :span="20">
                            <el-form-item label="请假原因:">
                                <el-input v-model="applyDetail.reason"
                                          disabled></el-input>
                            </el-form-item>
                            <el-form-item label="个人请假类型:">
                                <el-select
                                        v-model="applyDetail.reason_type_id"
                                        placeholder="请选择"
                                        disabled>
                                    <el-option
                                            v-for="item in status_types"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="请假凭据:">
                                <img v-for="(studentApplyCredential,index) in applyDetail.studentApplyCredential"
                                     :key="index" :src="studentApplyCredential.credential" alt=""
                                     style="width: 150px;height: 150px"
                                     @click="handleShowCredentialDetail(studentApplyCredential.credential)">
                                <el-dialog
                                        title="凭据图片"
                                        :visible.sync="dialogVisible"
                                        :modal="false"
                                        width="50%">
                                    <img :src="credential" alt="" style="height: 100%;width: 100%">
                                    <span slot="footer" class="dialog-footer">
                                        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
                                    </span>
                                </el-dialog>
                            </el-form-item>
                            <el-form-item label="班主任备注:">
                                <el-input v-model="applyDetail.teacher_remark" type="textarea" :rows="1" disabled></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </el-form>
            <div>
                {{$parentInfo.studentPeriod.switchingPeriod.message}}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                dialogVisible: false,
                credential:'',
                status_types:[
                    {
                        value:1,
                        label:'个人原因'
                    },
                    {
                        value:2,
                        label:'病假'
                    },
                    {
                        value:3,
                        label:'个人社会实践'
                    },
                    {
                        value:4,
                        label:'学校集体活动'
                    },
                ],
            };
        },
        props: {
            classPlanStudent_id: {
                default: 0,
            },
        },
        computed: {},
        mounted() {},
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
        },
        methods: {
            handleShowCredentialDetail(credential) {
                this.credential = credential;
                this.dialogVisible = true;
            },
        }
    };
</script>

<style scoped>

</style>
